import { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const ConfirmDelete = (props) => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    props.deleteConfirmMessage();
  };


  return (
    <div className="popup-box">
      <h4 className="title">{props.t("delete_confirmation")}</h4>
      <p className="popup-error-msg">{props.t("are_you_sure_you_want_to_delete")} ?</p>
      <div className="text-center pt-1 d-flex gap-2 justify-content-center">
        <button
          onClick={handleButtonClick}
          onTouchStart={handleButtonClick}
          onTouchEnd={(e) => e.preventDefault()}
        >
          {props.t("yes")}
        </button>
        <button onClick={props.handle}>
          {props.t("no")}
        </button>
      </div>
    </div>
  );
};

ConfirmDelete.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

ConfirmDelete.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ConfirmDelete);
